import React from 'react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

export function Field({ id, label, hint, optional, children }) {
  return (
    <div className="space-y-1">
      <Label htmlFor={id} className="text-sm font-semibold text-slate-800">{label}{optional && <span className="text-slate-400 font-normal"> (optional)</span>}</Label>
      {children}
      {hint && <p className="text-xs text-slate-500">{hint}</p>}
    </div>
  );
}

export function TextField({ id, label, value, onChange, placeholder, type = 'text', optional, hint, inputMode }) {
  return (
    <Field id={id} label={label} optional={optional} hint={hint}>
      <Input id={id} type={type} inputMode={inputMode} value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={`ww-${id}`} className="h-11 text-base" />
    </Field>
  );
}

export function TextAreaField({ id, label, value, onChange, placeholder, rows = 4, optional, hint }) {
  return (
    <Field id={id} label={label} optional={optional} hint={hint}>
      <Textarea id={id} value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} rows={rows} data-testid={`ww-${id}`} className="text-base" />
    </Field>
  );
}

export function YesNo({ id, label, value, onChange, hint }) {
  const opt = (v, text) => (
    <button key={v} type="button" onClick={() => onChange(v)} data-testid={`ww-${id}-${v}`} aria-pressed={value === v}
      className={`flex-1 h-11 rounded-lg border text-sm font-semibold transition-colors ${value === v ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-700 border-slate-300 hover:border-slate-500'}`}>{text}</button>
  );
  return (
    <Field id={id} label={label} hint={hint}>
      <div className="flex gap-2">{opt('yes', 'Yes')}{opt('no', 'No')}</div>
    </Field>
  );
}

export function ColourField({ id, label, value, onChange, disabled }) {
  return (
    <Field id={id} label={label}>
      <div className="flex items-center gap-2">
        <input type="color" value={value || '#000000'} onChange={(e) => onChange(e.target.value)} disabled={disabled} data-testid={`ww-${id}-picker`} className="h-11 w-14 rounded-md border border-slate-300 bg-white p-1 disabled:opacity-40" />
        <Input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="#0f766e" disabled={disabled} data-testid={`ww-${id}`} className="h-11 font-mono text-base" />
      </div>
    </Field>
  );
}

export function StepIntro({ title, text }) {
  return (
    <div className="mb-5">
      <h2 className="text-xl md:text-2xl font-bold text-slate-900" data-testid="ww-step-title">{title}</h2>
      {text && <p className="text-sm text-slate-600 mt-1">{text}</p>}
    </div>
  );
}
